import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * Content:
 *  - Content for a Tour component
 */
export function Content(props) {
  return (
    <p className={`${style.content} ${props.className}`}>{props.content}</p>
  );
}

Content.propTypes = {
  /**
   * content to be displayed as feedback
   */
  content: PropTypes.string.isRequired,
};

Content.defaultProps = {
  content:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elitut ipsum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam at eros at ligula luctus cursus. Donec faucibus nunc ",
  className: "",
};
